import { MockExamDetailPage } from "@/features/learning-content/pages/MockExamDetail";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const MockExamDetail: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <MockExamDetailPage />
      </Box>
    </Stack>
  );
};

export default MockExamDetail;
